import { ENV } from '~/common/enums/enums';
import { SeoPayload } from '~/common/types/types';

const seoPayload: SeoPayload = {
  title: 'seo.bs.title',
  description: 'seo.bs.description',
  siteUrl: ENV.APP.URL,
};

export { seoPayload };
